import { EndSponsorPointRateRequest } from '../request-models/end-sponsor-point-rate-request.model';
import { SponsorCreateRequest } from '../request-models/sponsor-create-request.model';
import { SponsorLocationCreateRequest } from '../request-models/sponsor-location-create-request.model';
import { SponsorLocationUpdateRequest } from '../request-models/sponsor-location-update-request.model';
import { SponsorPointRateCreateRequest } from '../request-models/sponsor-point-rate-create-request.model';
import { SponsorPointRateUpdateRequest } from '../request-models/sponsor-point-rate-update-request.model';
import { SponsorRepresentativeCreateRequest } from '../request-models/sponsor-representative-create-request.model';
import { SponsorRepresentativeUpdateRequest } from '../request-models/sponsor-representative-update-request.model';
import { SponsorUpdateRequest } from '../request-models/sponsor-update-request.model';
import { omitUndefined } from './wire-value-utils';

// The hub has no `_WRITABLE` list for sponsors: each builder copies exactly the fields that
// `admin-sponsors-controller.ts` reads from the body, only when set. `null` (clear the field) is kept.

/** PUT /admin/sponsors/:id */
export function toSponsorUpdateRequest(fields: SponsorUpdateRequest): SponsorUpdateRequest {
  return omitUndefined<SponsorUpdateRequest>({
    name: fields.name,
    logoUrl: fields.logoUrl,
    website: fields.website,
    phone: fields.phone,
    email: fields.email,
    brandColor: fields.brandColor,
    description: fields.description,
    contactType: fields.contactType,
    contactMessage: fields.contactMessage,
  });
}

/** POST /admin/sponsors */
export function toSponsorCreateRequest(fields: SponsorCreateRequest): SponsorCreateRequest {
  return { ...toSponsorUpdateRequest(fields), name: fields.name };
}

/** PUT /admin/sponsors/:id/rates/:rateId */
export function toSponsorPointRateUpdateRequest(fields: SponsorPointRateUpdateRequest): SponsorPointRateUpdateRequest {
  return omitUndefined<SponsorPointRateUpdateRequest>({
    chemicalId: fields.chemicalId,
    rateValue: fields.rateValue,
    rateUnit: fields.rateUnit,
    calculationMode: fields.calculationMode,
    effectiveStart: fields.effectiveStart,
    effectiveEnd: fields.effectiveEnd,
  });
}

/** POST /admin/sponsors/:id/rates */
export function toSponsorPointRateCreateRequest(fields: SponsorPointRateCreateRequest): SponsorPointRateCreateRequest {
  return {
    ...toSponsorPointRateUpdateRequest(fields),
    chemicalId: fields.chemicalId,
    rateValue: fields.rateValue,
    rateUnit: fields.rateUnit,
    effectiveStart: fields.effectiveStart,
  };
}

/** POST /admin/sponsors/:id/rates/:rateId/end */
export function toEndSponsorPointRateRequest(fields: EndSponsorPointRateRequest): EndSponsorPointRateRequest {
  return { endDate: fields.endDate };
}

/** PUT /admin/sponsors/:id/locations/:locationId */
export function toSponsorLocationUpdateRequest(fields: SponsorLocationUpdateRequest): SponsorLocationUpdateRequest {
  return omitUndefined<SponsorLocationUpdateRequest>({
    name: fields.name,
    street1: fields.street1,
    street2: fields.street2,
    city: fields.city,
    state: fields.state,
    zipCode: fields.zipCode,
    latitude: fields.latitude,
    longitude: fields.longitude,
    phone: fields.phone,
    email: fields.email,
  });
}

/** POST /admin/sponsors/:id/locations */
export function toSponsorLocationCreateRequest(fields: SponsorLocationCreateRequest): SponsorLocationCreateRequest {
  return {
    ...toSponsorLocationUpdateRequest(fields),
    name: fields.name,
    street1: fields.street1,
    city: fields.city,
    state: fields.state,
    zipCode: fields.zipCode,
  };
}

/** PUT /admin/sponsors/:id/representatives/:repId */
export function toSponsorRepresentativeUpdateRequest(fields: SponsorRepresentativeUpdateRequest): SponsorRepresentativeUpdateRequest {
  return omitUndefined<SponsorRepresentativeUpdateRequest>({
    name: fields.name,
    title: fields.title,
    territory: fields.territory,
    phone: fields.phone,
    email: fields.email,
  });
}

/** POST /admin/sponsors/:id/representatives */
export function toSponsorRepresentativeCreateRequest(fields: SponsorRepresentativeCreateRequest): SponsorRepresentativeCreateRequest {
  return { ...toSponsorRepresentativeUpdateRequest(fields), name: fields.name };
}
